import app, { Component } from 'apprun';
import { serializeObject, locations, users as usersApi } from './api';
import { isValid, showSaveStatusMessage, lookup_en,isStringEqual, isDateRangeOverlap } from './utils';
import moment from 'moment';
import PasswordInput from './password-input';
export default class UserReactivateComponent extends Component {
  view = (state) => {
    if (!state?.profile) {return;}

    return (
      <div key={state.personId} style={{ width: '400px' }}>
        <form id="userReactivateForm">
          <div class="list-group">
            <div class="list-group-item">
              Personnel Type: &nbsp;
              <select name="employeeTypeCt" id="employeeTypeCt" oninput={e => this.run('empTypeChanged', e.target.value)} class='pull-right'>
                {lookup_en.EmployeeTypeCt.map(r => <option value={r.id} selected = {isStringEqual(r.id,state.profile.employeeTypeCt)?'selected':''}>{r.value} </option>)}
              </select>
              <div id="companyNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              First Name: <input id="firstName" name="firstName" value={state.profile.firstName} class='pull-right' data-validate />
              <div id="firstNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              Last Name: <input id="lastName" name="lastName" value={state.profile.lastName}  class='pull-right' data-validate />
              <div id="lastNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              User Name:
              <div>
                <input id="username" name="username" value={state.profile.username} disabled data-validate />@
                <select id="domain" name="domain" disabled>
                  <option value="royallepage.ca" selected = {isStringEqual(state.profile.domain, 'royallepage.ca')?'selected':null} >royallepage.ca</option>
                  <option value="johnstonanddaniel.com" selected = {isStringEqual(state.profile.domain, 'johnstonanddaniel.com')?'selected':null}>johnstonanddaniel.com</option>
                </select>
              </div>
              <div id="usernameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              Select Password: <PasswordInput id="password" name="password" class='pull-right' />
              <div id="passwordErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              Company:
              <select id="companyID" name="companyID" value={state.profile.companyID} data-validate="Int" oninput={e => this.run('companySelectionChanged', e.target.value)} style={{ 'width': '300px' }} class='pull-right'>
                <option value="0">[Select]</option>
                {state.brokerageOptions.map(r =>
                  (<option value={r.id} selected={isStringEqual(r.id, state.profile.companyID) ? 'selected' : null}>{r.id + ' - ' + r.name}</option>)
                )}
              </select>
              <div id="companyIDErrMsg" class="text-danger" />
            </div>
            <div class="list-group-item">
              Location:
              <select id="primaryLocationID" name="primaryLocationID" style={{ 'width': '300px' }} data-validate="Int" class='pull-right' oninput={e => this.run('locationSelectionChanged', e.target.value)}>
                {state.companyId === 0 ? <option value="0">Select Company First</option> : <option value="0">[Select]</option>}
                {state.locationOptions.map(r =>
                  (<option value={r.id} selected={isStringEqual(r.id, state.profile.primaryLocationID) ? 'selected' : null}>{r.id + ' - ' + r.name}</option>)
                )}
              </select>
              <div id="primaryLocationIDErrMsg" class="text-danger" />
            </div>
            <div class="list-group-item">
              Language:
              <select id="preferredLangCt" name="preferredLangCt" class='pull-right'>
                {lookup_en.LangCt.map(r => <option value={r.id} selected={isStringEqual(r.id, state.profile.preferredLangCt) ? 'selected' : null}>{r.value}</option>)}
              </select>
              <div id="preferredLangCtErrMsg" class="text-danger"></div>
            </div>
            {
              state.isAgent
                ?
                <div class="list-group-item">
                  Sales Kit Required:
                  <select id="salesKitRequired" name="dispKitQ" required="required" data-validate="Int-1" class='pull-right'>
                    {lookup_en.ReceiveSalesKitRequest.map(r => <option value={r.id}>{r.value === 'e' ? 'English' : r.value === 'f' ? 'French' : r.value === 'n' ? 'No' : ''}</option>)}
                  </select>
                  <div id="salesKitRequiredErrMsg" class="text-danger"></div>
                </div>
                :
                null
            }
            <div class="list-group-item" >
              Recruitment Source:
              <select name="recruitmentSource" id="recruitmentSource"  required="required" data-validate="Int-1" style={{ 'width': '200px' }} class='pull-right'>
                {lookup_en.RecruitmentSource.map(r => <option value={r.id}>{r.value}</option>)}
              </select>
              <div id="recruitmentSourceErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item" >
              Previous Affiliation:
              <select name="previousAffiliation" id="previousAffiliation" required="required" data-validate="Int-1" oninput={e => this.run('prevAffiliationChanged', e.target.value)} style={{ 'width': '200px' }} class='pull-right'>
                {lookup_en.PreviousAffiliation.map(r => <option value={r.id}>{r.value}</option>)}
              </select>
              <div id="previousAffiliationErrMsg" class="text-danger"></div>
            </div>
            {
              state.dispAffilDetail
                ?
                <div class="list-group-item" style={{ 'display': state.dispAffilDetail ? 'disp' : 'none' }} >
                  Previous Affiliation details: <input id="previousAffiliationDetail" name="previousAffiliationDetail" class='pull-right' data-validate />
                  <div id="previousAffiliationDetailErrMsg" class="text-danger"></div>
                </div>
                :
                null
            }
            <input style={{ 'display': 'none' }} /><input style={{ 'display': 'none' }} />
            <div class="list-group-item">
              Activation Date: <input $pikaday autocomplete="off" id="startDate" name="startDate" class='pull-right' placeholder="DD-MMM-YYYY" data-validate="Date" />
              <div id="startDateErrMsg" class="text-danger"></div>
            </div>
          </div>
        </form>
        <div class="edit-buttons">
          <button class="btn btn-default btn-xs pull-right" onclick={() => this.run('cancel')}>cancel</button>
                    &nbsp;
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('save')} >Reactivate</button>
        </div>
      </div>
    );
  }

  update = {

    empTypeChanged: (state, idx) => {
      const isAgent = idx === '1' || idx === '8';
      state.profile.employeeTypeCt = idx;
      return { ...state, isAgent };
    },

    prevAffiliationChanged: (state, idx) => {
      const dispAffilDetail = idx === '354';
      if (dispAffilDetail !== state.dispAffilDetail) {
        state.picker = null;
      }
      return { ...state, dispAffilDetail };
    },

    companySelectionChanged: async (state, idx) => {
      state.profile.companyID = idx;
      state.locationOptions =
        state.profile.companyID === 0 ? [] : await locations.getLocationsByCompanyID(state.profile.companyID);
      return state;
    },

    locationSelectionChanged: (state, idx) => {
      state.profile.primaryLocationID = idx;
      return state;
    },

    checkAvailability: async (state) => {
      const userName = (document.getElementById('username') as HTMLInputElement).value.trim();
      const userDomain = (document.getElementById('domain') as HTMLInputElement).value.trim();

      if (userName.length === 0) {
        state.availabilityMessage = 'Please provide Username';
      } else {
        const emailAddress = userName + '@' + userDomain;
        const result = await usersApi.checkEmailAvailability(emailAddress);

        state.availabilityMessage = emailAddress + ' is ' + (result ? 'available' : 'unavailable');
      }

      return state;
    },

    save: async (state) => {
      try{
        const formName = 'userReactivateForm';
        if (!isValid(formName)) {return;}

        const startDate = moment((document.getElementById('startDate') as HTMLInputElement).value.trim()).format('YYYY-MM-DD');
        const endDate = '9999-12-31';

        if(isDateRangeOverlap(startDate, endDate, state.profile.employeeDateHistory)) {
          const errDiv = (document.getElementById('startDateErrMsg') as HTMLDivElement);
          errDiv.innerHTML =  'Start date is between another period of employment';
          return;
        }

        const formData = serializeObject(document.getElementById(formName));
        formData['hdnP'] = state.personId;
        const result = await usersApi.reactivateUser(formData);
        showSaveStatusMessage('user');
        if (result) {this.run('#sub-panel-done', 'userReactivate');}
      }catch{
        showSaveStatusMessage();
      }
    },

    cancel: () => {
      app.run('#clear-panel', 'userReactivate');
    },
  };

  mounted = ({ state }) => {
    const isAgent = state.profile.employeeTypeCt === '1' || state.profile.employeeTypeCt === '8';
    return { ...state, dispAffilDetail:false,formFilled:false, isAgent: isAgent, };
  }

}
